"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function colorSelect(value, colors = ['#1d47b0', '#ce8b2b', '#b4312d']) {
    if (value < 85) {
        return colors[0];
    }
    if (value < 95) {
        return colors[1];
    }
    return colors[2];
}
exports.default = colorSelect;
